import CartSearchPage from '../components/CartSearchPage.vue';
import CartStep from '../components/CartStep.vue';
import CartLandingPage from '../components/CartLandingPage.vue';

/**
 * Generates the common cart route configuration
 * @param {string} prefix - Prefix for route names ('Portal_' or '')
 * @param {Object} options - Additional options for route configuration
 * @returns {Object} Route configuration object
 */
function generateCartRoutes(prefix = '', options = {}) {
    const routes = [
        {
            path: '',
            name: `${prefix}CartLandingPage`,
            component: CartLandingPage,
            transition: 'slide-left',
            props: true,
        },
        {
            path: 'search/',
            name: `${prefix}CartSearchPage`,
            component: () => import(/* webpackChunkName: "cart-search", webpackPrefetch: true */ '../components/CartSearchPage.vue'),
            props: true
        },
        {
            path: 'step/:stepIndex/',
            name: `${prefix}CartStep`,
            component: () => import(/* webpackChunkName: "cart-step", webpackPrefetch: true */ '../components/CartStep.vue'),
            props: true,
            ...(options.meta && { meta: options.meta })
        },
        {
            path: 'checkout/',
            name: `${prefix}CartPaymentScreen`,
            component: () => import(/* webpackChunkName: "cart-payment", webpackPrefetch: true */ '../components/CartPaymentScreen.vue'),
            props: (route) => ({ clientSecret: route.query.clientSecret })
        }
    ];

    // Add auth route only for unauthenticated cart
    if (!prefix) {
        routes.push({
            path: 'auth/',
            name: 'CartAuth',
            component: () => import(/* webpackChunkName: "cart-auth", webpackPrefetch: true */ '../components/CartStepAuth.vue'),
            props: true
        });
    }

    return {
        path: '',
        name: `${prefix}Cart`,
        component: () => import('../views/CartView.vue'),
        props: route => ({ cartSlug: route.params.cartSlug }),
        children: routes
    };
}

export const unauthenticatedCartRoutes = {
    path: '/cart/c/:cartSlug/',
    name: 'CartHome',
    component: () => import('../components/layouts/FullWidth.vue'),
    props: route => ({ cartSlug: route.params.cartSlug }),
    children: [generateCartRoutes()]
};

export const authenticatedCartRoutes = {
    path: 'cart/:cartSlug/',
    name: 'Portal_CartHome',
    component: () => import('../components/layouts/PortalLayout.vue'),
    props: route => ({ cartSlug: route.params.cartSlug }),
    meta: { inPortal: true },
    children: [generateCartRoutes('Portal_', { meta: { layoutClass: 'col-lg-11' } })]
};